import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import Fa from 'react-fontawesome';
import enhanceWithClickOutside from 'react-click-outside';
import { FormGroup, FormControl, InputGroup, Button } from 'react-bootstrap';
import styles from './styles.css';


class SearchField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: props.query || '',
      focus: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.clear = this.clear.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleChange(event) {
    const query = event.target.value;
    const newQuery = (query || '').replace(/[\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'); // eslint-disable-line
    this.setState({ query });
    this.props.onSearch(newQuery);
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.autoFocus && this.input) {
      delay(() => {
        if (this.mounted) {
          this.input.focus();
          this.input.setSelectionRange(0, this.input.value.length);
        }
      }, 100);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleKeyUp(event) {
    const { key } = event;
    event.stopPropagation();
    if (key === 'Escape') {
      this.clear();
    }
  }

  clear() {
    const query = '';
    this.setState({ query });
    this.props.onSearch(query);
    if (this.state.focus && this.input) {
      this.input.focus();
    }
  }

  handleFocus() {
    this.setState({ focus: true });
    this.props.onFocus();
  }

  handleBlur() {
    this.setState({ focus: false });
    this.props.onBlur();
  }

  handleClickOutside() {
    this.handleBlur();
  }

  render() {
    const {
      placeholder, collapsible, disabled, width,
    } = this.props;
    const { query, focus } = this.state;
    const isSearching = query && query.trim().length;
    const style = {
      width,
    };
    if (collapsible) {
      style.width = focus ? 'auto' : width;
    }
    return (
      <FormGroup
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        className={`${styles.queryField} ${focus ? styles.focus : ''}`}
      >
        <InputGroup bsSize="sm" style={style}>
          <FormControl
            type="text"
            value={query}
            disabled={disabled}
            onKeyUp={this.handleKeyUp}
            onChange={this.handleChange}
            placeholder={placeholder}
            
            onFocus={this.handleFocus}
            inputRef={(ref) => { this.input = ref; }}
          />
          {!isSearching &&
            <InputGroup.Addon>
              <Fa name="search" />
            </InputGroup.Addon>
          }
          {isSearching &&
            <InputGroup.Button>
              <Button bsStyle="link" disabled={disabled} onClick={this.clear}><Fa name="times-circle" /></Button>
            </InputGroup.Button>
          }
        </InputGroup>
      </FormGroup>
    );
  }
}


SearchField.propTypes = {
  disabled: PropTypes.bool,
  width: PropTypes.number,
  onSearch: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  query: PropTypes.string,
  collapsible: PropTypes.bool,
  autoFocus: PropTypes.bool,
};
SearchField.defaultProps = {
  disabled: false,
  autoFocus: false,
  placeholder: 'Search...',
  collapsible: true,
  query: null,
  width: 120,
  onSearch: () => {},
  onFocus: () => {},
  onBlur: () => {},
};

export default enhanceWithClickOutside(SearchField);
